import { mailSaga } from '@module/ComposeEmail/redux/saga'
import { playerSaga } from '@module/Player/redux/saga'
import * as Sentry from '@sentry/react'
import { all } from 'redux-saga/effects'

export default function* rootSaga() {
  try {
    yield all([playerSaga(), mailSaga()])
  } catch (err) {
    Sentry.captureException(
      err?.message ||
        'Error in on of the sagas (This is a mock error message due to the absence of the original error message)'
    )
  }
}
